export default __webpack_public_path__ + "media/images/quotation-0904580d8596b4347cdc8287fc9dab80.svg";